export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'iconm-meter',
      role: false,
    },
    // {
    //   name: 'Products',
    //   url: '/products',
    //   icon: 'iconm-packages',
    //   permission: ['read', 'create', 'update', 'delete'],
    // },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'iconm-users',
      permission: ['read', 'update', 'delete', 'export'],
    },
    {
      name: 'Messages',
      url: '/messages',
      icon: 'iconm-mail',
      permission: ['read', 'send', 'export', 'delete'],
    },
    {
      name: 'Rich Menu Management',
      url: '/rich-menu-management',
      icon: 'iconm-drm',
      permission: ['read', 'create', 'update', 'delete'],
    },
    {
      name: 'User Activities',
      url: '/user-activities',
      icon: 'iconm-window',
      permission: ['read'],
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'iconm-user',
      permission: ['read', 'create', 'update', 'delete'],
    },
    {
      name: 'Transactional message',
      url: '/tm-dashboard',
      icon: 'iconm-meter',
      permission: ['read', 'update', 'delete', 'export'],
      children: [
        {
          name: 'TM Dashboard',
          url: '/tm-dashboard',
          permission: ['read', 'update', 'delete', 'export'],
        },
        {
          name: 'Transactional log',
          url: '/transaction-log',
          permission: ['read', 'update', 'delete', 'export'],
        },
      ]
    },
    // {
    //   name: 'Purchase History',
    //   url: '/purchaseHistory',
    //   icon: 'iconm-shopping',
    //   permission: ['read', 'create', 'update', 'delete'],
    // },
    {
      name: 'Activity Log Report',
      url: '/activityLog',
      icon: 'iconm-clipboard',
      permission: ['read', 'export'],
    },
    // {
    //   name: 'Register incomplete',
    //   url: '/reports',
    //   icon: 'iconm-file-missing',
    //   permission: ['read'],
    // },
    {
      name: 'A Buddy',
      url: '/abuddy',
      icon: 'iconm-Message1',
      permission: ['read', 'create', 'update', 'delete'],
      children: [
        {
          name: 'Intro OA',
          url: '/abuddy/intro-oa',
          permission: ['read'],
        },
        {
          name: 'Intro Group',
          url: '/abuddy/intro-group',
          permission: ['read'],
        },
        {
          name: 'Category',
          url: '/abuddy/category',
          permission: ['read'],
        },
        {
          name: 'Sub Category',
          url: '/abuddy/sub-category',
          permission: ['read'],
        },
        {
          name: 'Quick Reply',
          url: '/abuddy/quick-reply',
          permission: ['read'],
        },
        {
          name: 'Smart Report',
          url: '/abuddy/smart-report',
          permission: ['read'],
        },
      ],
    },
    {
      name: 'Library',
      url: '/library',
      icon: 'iconm-Message1',
      permission: ['read', 'create', 'update', 'delete'],
      children: [
        {
          name: 'Main Category',
          url: '/library/main-category',
          permission: ['read'],
        },
        {
          name: 'Sub Category',
          url: '/library/sub-category',
          permission: ['read'],
        },
      ],
    },
    {
      name: 'Content Management',
      url: '/content-management',
      icon: 'iconm-window',
      permission: ['read', 'create', 'update', 'delete'],
      children: [
        {
          name: 'Admin',
          url: '/content-management/admin-management',
          permission: ['read'],
        },
        {
          name: 'ABO',
          url: '/content-management/abo-management',
          permission: ['read'],
        },
      ],
    },
    {
      name: 'Live Chat',
      url: '/chatlive',
      icon: 'iconm-Setting',
      permission: ['read', 'create', 'update', 'delete'],
      children: [
        {
          name: 'List Options',
          url: '/chatlive/list-option',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'Schedules',
          url: '/chatlive/schedule',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'Off Hour',
          url: '/chatlive/off-hour',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'Survey',
          url: '/chatlive/survey',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'Department',
          url: '/chatlive/department',
          permission: ['read', 'create', 'update', 'delete'],
        },
      ],
    },
    {
      name: 'Assessment',
      url: '/assesment',
      icon: 'iconm-window',
      permission: ['read', 'create', 'update', 'delete'],
      children: [
        {
          name: 'ListAssesment',
          url: '/assesment/list-assesment',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListSuggestion',
          url: '/assesment/list-suggestion',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListSolution',
          url: '/assesment/list-solution',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'TermsConditions',
          url: '/assesment/list-conditions',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListType',
          url: '/assesment/list-type',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListFoodCat',
          url: '/assesment/list-food-cat',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListFoodMenu',
          url: '/assesment/list-food-menu',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListFoodMenuABO',
          url: '/assesment/list-food-menu-ABO',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListSupplement',
          url: '/assesment/list-supplement',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListExerciseCat',
          url: '/assesment/list-exercise-category',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListExerciseMenu',
          url: '/assesment/list-exercise-menu',
          permission: ['read', 'create', 'update', 'delete'],
        },
        {
          name: 'ListExerciseTemp',
          url: '/assesment/list-exercise-temp',
          permission: ['read', 'create', 'update', 'delete'],
        },
      ],
    },
    {
      name: 'Challenge',
      url: '/challenge',
      icon: 'iconm-bullseye',
      permission: ['read', 'create', 'update', 'delete'],
    },
    {
      name: 'GMN Message',
      url: '/gmn-daily-message',
      icon: 'iconm-gmn-message',
      permission: ['read', 'create', 'update', 'delete'],
    },
  ],
};
